import React from 'react';
import Storage from '../Storage';
import * as actions from '../redux/actions';

class SheldonSidebarLinks extends React.Component {
  constructor(props) {
    super(props);

    let { hostInfo, dispatch } = props;
    if (hostInfo.id) {
      hostInfo.kskUseVpnIPAddr = Storage.getSessionItem('kskUseVpnIPAddr:' + hostInfo.id);
      dispatch(actions.updateHostInfo(hostInfo));
    }

    this.state = {
      kskUseVpnIPAddr: hostInfo.kskUseVpnIPAddr,
    };

    this.handleToggleKskUseVpnIPAddr = this.handleToggleKskUseVpnIPAddr.bind(this);
  }

  componentWillUpdate(nextProps) {
    // to handle browser page refresh
    if (this.props.hostInfo.id !== nextProps.hostInfo.id) {
      let { hostInfo, dispatch } = nextProps;
      hostInfo.kskUseVpnIPAddr = Storage.getSessionItem('kskUseVpnIPAddr:' + hostInfo.id);
      dispatch(actions.updateHostInfo(hostInfo));
      this.setState({ kskUseVpnIPAddr: hostInfo.kskUseVpnIPAddr });
    }
  }

  handleToggleKskUseVpnIPAddr() {
    let { hostInfo, dispatch } = this.props;
    Storage.setSessionItem('kskUseVpnIPAddr:' + hostInfo.id, !hostInfo.kskUseVpnIPAddr);
    hostInfo.kskUseVpnIPAddr = !hostInfo.kskUseVpnIPAddr;
    dispatch(actions.updateHostInfo(hostInfo)); // so api requests to check for kskUseVpnIPAddr
    this.setState({ kskUseVpnIPAddr: hostInfo.kskUseVpnIPAddr });
  }

  render() {
    let {view, onLinkClick, hostInfo} = this.props;
    let {auth: {user}} = this.props;
    let {kskUseVpnIPAddr} = this.state;
    // hide ability to add/remove host for front level support role
    let isFrontLevelSupport = user.isFrontLevelSupportRole();
    let isBasicSupport = user.isBasicSupportRole();
    let isSuperRole = user.isSuperRole();
    let showActionSection = !isFrontLevelSupport;
    let showSomeActions = !isFrontLevelSupport && !isBasicSupport;

    return (
      <div className='pure-menu'>
        <ul className='pure-menu-list'>
          <li className='pure-menu-heading'>GET Info</li>
          <li className='pure-menu-item'>
            <a
              href='javascript:void(0)'
              onClick={onLinkClick.bind(this, 'filebrowser')}
              className={
                view == 'filebrowser' ? 'pure-menu-link pure-menu-link__selected' : 'pure-menu-link'
              }
            >
              File Browser
            </a>
          </li>
          <li className='pure-menu-item'>
            <a
              href='javascript:void(0)'
              onClick={onLinkClick.bind(this, 'cfg')}
              className={
                view == 'cfg' ? 'pure-menu-link pure-menu-link__selected' : 'pure-menu-link'
              }
            >
              Config
            </a>
          </li>
          <li className='pure-menu-item'>
            <a
              href='javascript:void(0)'
              onClick={onLinkClick.bind(this, 'gmainspect')}
              className={
                view == 'gmainspect' ? 'pure-menu-link pure-menu-link__selected' : 'pure-menu-link'
              }
            >
              GMA Inspect
            </a>
          </li>
          <li className='pure-menu-item'>
            <a
              href='javascript:void(0)'
              onClick={onLinkClick.bind(this, 'stats')}
              className={
                view == 'stats' ? 'pure-menu-link pure-menu-link__selected' : 'pure-menu-link'
              }
            >
              Linux Stats
            </a>
          </li>
{/*
          <li className="pure-menu-item">
            <a href="javascript:void(0)"
               onClick={onLinkClick.bind(this, 'trans')}
               className={view == 'trans' ? 'pure-menu-link pure-menu-link__selected' : 'pure-menu-link'}>
              Sales/Transactions
            </a>
          </li>
*/}
        </ul>
        {showActionSection && (
          <ul className='pure-menu-list'>
            <li className='pure-menu-heading'>Actions</li>
            <li className='pure-menu-item'>
              <a
                href='javascript:void(0)'
                onClick={onLinkClick.bind(this, 'cmd')}
                className={
                  view === 'cmd' ? 'pure-menu-link pure-menu-link__selected' : 'pure-menu-link'}
              >
                Command Launcher
              </a>
            </li>
            {showSomeActions && (
              <li className='pure-menu-item'>
                <a
                  href='javascript:void(0)'
                  onClick={onLinkClick.bind(this, 'updkskcfg')}
                  className={
                    view === 'updkskcfg'
                      ? 'pure-menu-link pure-menu-link__selected'
                      : 'pure-menu-link'}
                >
                  Update kskcfg
                </a>
              </li>
            )}
            {showSomeActions && (
              <li className='pure-menu-item'>
                <a
                  href='javascript:void(0)'
                  onClick={onLinkClick.bind(this, 'payapicmd')}
                  className={
                    view === 'payapicmd'
                      ? 'pure-menu-link pure-menu-link__selected'
                      : 'pure-menu-link'}
                >
                  payapi Commands
                </a>
              </li>
            )}
            {showSomeActions && (
              <li className='pure-menu-item'>
                <a
                  href='javascript:void(0)'
                  onClick={onLinkClick.bind(this, 'setup')}
                  className={
                    view === 'setup' ? 'pure-menu-link pure-menu-link__selected' : 'pure-menu-link'}
                >
                  Remote Setup
                </a>
              </li>
            )}
            {showSomeActions && (
              <li className='pure-menu-item'>
                <a
                  href='javascript:void(0)'
                  onClick={onLinkClick.bind(this, 'kiosk-updater')}
                  className={
                    view === 'kiosk-updater'
                      ? 'pure-menu-link pure-menu-link__selected'
                      : 'pure-menu-link'}
                >
                  Kiosk Updater
                </a>
              </li>
            )}
            {showSomeActions && (
              <li className='pure-menu-item'>
                <a
                  href='javascript:void(0)'
                  onClick={onLinkClick.bind(this, 'dashbeat-command')}
                  className={
                    view === 'dashbeat-command'
                      ? 'pure-menu-link pure-menu-link__selected'
                      : 'pure-menu-link'}
                >
                  DashBeat Command
                </a>
              </li>
            )}
            {isSuperRole && showSomeActions && (
              <li className='pure-menu-item'>
                <a
                  href='javascript:void(0)'
                  onClick={onLinkClick.bind(this, 'linuxdash-command')}
                  className={
                    view === 'linuxdash-command'
                      ? 'pure-menu-link pure-menu-link__selected'
                      : 'pure-menu-link'}
                >
                  linuxdash Commands
                </a>
              </li>
            )}
          </ul>
        )}

        {showSomeActions && hostInfo.isMQKskType && (
          <div style={{ margin: '0 20px' }}>
            <input
              type='checkbox'
              onChange={this.handleToggleKskUseVpnIPAddr}
              checked={kskUseVpnIPAddr}
            />
            <a
              href='javascript:void(0)'
              onClick={this.handleToggleKskUseVpnIPAddr}
              className='pure-menu-toggle-link'
            >
              Force to use IP Address instead of tally/MQ
            </a>
          </div>
        )}
      </div>
    );
  }
}

export default SheldonSidebarLinks;



// WEBPACK FOOTER //
// ./src/components/SheldonSidebarLinks.js